export const adminNavList = [
  {
    navName: '历史建筑管理',
    path: '/relic'
  },
  // {
  //   navName: '巡查报告',
  //   path: '/report'
  // },
  // {
  //   navName: 'GIS查询',
  //   path: '/gis'
  // },
  // {
  //   navName: '修缮记录',
  //   path: '/repair'
  // },
  {
    navName: '用户管理',
    path: '/manage'
  },
  // {
  //   navName: '标签管理',
  //   path: '/tagManage'
  // },
  {
    navName: '进入地图',
    path: '/map'
    // target: '_blank'
  }
];
export const navList = [
  {
    navName: '历史建筑管理',
    path: '/relic'
  },
  // {
  //   navName: '巡查报告',
  //   path: '/report'
  // },
  // {
  //   navName: 'GIS查询',
  //   path: '/gis'
  // },
  // {
  //   navName: '修缮记录',
  //   path: '/repair'
  // },
  // {
  //   navName: '标签管理',
  //   path: '/tagManage'
  // },
  {
    navName: '进入地图',
    path: '/map'
    // target: '_blank'
  }
];
